import videojs from "video.js";
import VerseImaPlugin from "./VerseImaPlugin";
import * as VerseImaEvent from "./VerseImaEvent";

export { VerseImaEvent };

videojs.plugin(
  "verseImaAds",
  // Don't use an arrow function here. Video.js plugins are called with `this` set to the current
  // videojs instance. We need access to that so we can't use an arrow function.
  function (options) {
    if (!options.canPlayAds) {
      return;
    }

    const player = this;

    if (!player.verseAds) {
      player.verseAds = new VerseImaPlugin(player, options);
      player.verseAds.init();
    } else {
      //console.log(player === player.verseAds.player);
      player.verseAds.updateOptions(options);
      player.verseAds.updatePlayer(player);
    }

    player.verseAds.play();
  },
);
